import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { UnhandledErrorDisplay } from '@/shared/components/errors/unhandled-error-display';

/**
 * Displays an error screen whenever the app experiences an unhandled exception.
 */
export function UnhandledErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary FallbackComponent={UnhandledErrorDisplay}>
      {children}
    </ErrorBoundary>
  );
}
